import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-[#e2e8f0] py-10 mt-12 bg-white/70">
      <div className="container-custom px-4 flex flex-col sm:flex-row justify-between gap-6 text-sm text-[#475569]">
        <div>
          <p className="text-[#0f172a] font-semibold">Crystal Dental Clinic</p>
          <p>{t('footer.tagline')}</p>
        </div>
        <div className="flex gap-4">
          <Link to="/privacy" className="hover:text-[#0f172a]">{t('footer.privacy')}</Link>
          <Link to="/terms" className="hover:text-[#0f172a]">{t('footer.terms')}</Link>
          <span>© {new Date().getFullYear()}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
